// extracted by mini-css-extract-plugin
module.exports = {"container":"Address_container__2_spN","large":"Address_large__1y7zQ","small":"Address_small__1rZ1R"};